import styled from 'styled-components';

export const UnitFormModalContainer = styled.div`
    width: 20rem;
`;

export const FormContainer = styled.form``;
